<template>
  <div class="investment-checkout">
    <!-- 顶部标题 -->
    <div class="title-section">
      <h3>Transfer</h3>
      <p class="subtitle">Secure & Professional Fund Settlement</p>
    </div>
    <!--图片 -->
    <div class="static-image-card">
      <img src="@/assets/tz.png" alt="Payment Guide" class="static-image" loading="lazy" />
    </div>
    <!-- 订单信息与倒计时 -->
    <div class="info-card">
      <div class="order-info">
        <OrderIdComp :order-info="orderInfo" />
      </div>
      <div class="time-left">
        <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </div>
    </div>

    <!-- 收款信息 -->
    <div class="panel-card" v-if="orderInfo.orderId">
      <div class="info-item">
        <div class="item-label" style="width: 50px">Bank:</div>
        <div class="item-value" :class="{ copied: copyBankIf }">
          <span v-if="copyBankIf" style="color: #2f855a;"><b>{{ orderInfo.recBank }}</b></span>
          <span v-else style="color: #2c5282;"><b>{{ orderInfo.recBank }}</b></span>
        </div>
        <button v-on:click="copyBank" class="copy-btn">Copy</button>
      </div>
      <div class="info-item">
        <div class="item-label">Receiver's:</div>
        <div class="item-value" :class="{ copied: copyOwnerIf }">
          <span v-if="copyOwnerIf" style="color: #2f855a;"><b>{{ orderInfo.recOwner }}</b></span>
          <span v-else style="color: #2c5282;"><b>{{ orderInfo.recOwner }}</b></span>
        </div>
        <button v-on:click="copyOwner" class="copy-btn">Copy</button>
      </div>
      <div class="info-item">
        <div class="item-label">CardNo:</div>
        <div class="item-value" :class="{ copied: copyCardNoIf }">
          <span v-if="copyCardNoIf" style="color: #2f855a;"><b>{{ orderInfo.recCardNo }}</b></span>
          <span v-else style="color: #2c5282;"><b>{{ orderInfo.recCardNo }}</b></span>
        </div>
        <button v-on:click="copyCardNo" class="copy-btn">Copy</button>
      </div>
      <div class="info-item amount-item">
        <div class="item-label">Amount:</div>
        <div class="item-value" :class="{ copied: copyAmountIf }">
          <span v-if="copyAmountIf" style="color: #2f855a;"><b>{{ orderInfo.amount }}</b></span>
          <span v-else style="color: #e53e3e;"><b>{{ orderInfo.amount }}</b></span>
        </div>
        <button @click="copyAmount" class="copy-btn">Copy</button>
      </div>
    </div>

    <!-- 提示以及操作区域 -->
    <div class="operation-card" v-if="orderInfo.orderId">
      <div class="step-guide">
        <div class="step-item">
          <div class="step-number">1</div>
          <div class="step-desc">Enter Reference Code.</div>
        </div>
        <div class="step-item">
          <div class="step-number">2</div>
          <div class="step-desc">Upload payment receipt image.</div>
        </div>
      </div>

      <div class="input-group">
        <input type="text" v-model="rcode" placeholder="Enter Reference Code." class="ref-input" />
        <button type="button" @click="rcodeSubmit()" class="action-btn submit-btn">
          Submit
        </button>
      </div>

      <div class="upload-container">
        <input ref="file1" type="file" name="file1" class="file-input"
          accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="fileSelected">
        <button class="action-btn upload-btn" @click="fileOpen">
          Upload the payment receipt image
        </button>
      </div>
    </div>

    <!-- 时间提示 & 注意事项-->
    <div class="tips-notice-card">
      <TimeTipsComp :order-info="orderInfo" />
      <div class="notice-card">
        <h4>Important Notices</h4>
        <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Please do not pay beyond the time limit,
          </span>otherwise it cannot be recovered!!!</p>
        <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Please do not modify the amount,
          </span>otherwise it cannot be recovered!!!</p>
        <p class="notice-item"><b>Notice:&nbsp;</b><span class="warning">Not checked before the next day, </span>cannot
          be recovered!!!</p>
        <p class="notice-item"><b>Notice:&nbsp;</b>Payment successful confirmation time: <span class="warning">5 to 10
            minutes</span>, After payment, The account has not been received for more than <span class="warning">10
            minutes,</span> Please contact customer service to check the order!</p>
      </div>
    </div>

    <!-- 二维码区域 -->
    <div class="qr-card" v-if="recQrUrlImg">
      <h4>Alternative Payment: Scan QR Code</h4>
      <div class="qr-container">
        <div class="qr-image-wrapper">
          <img :src="recQrUrlImg" class="qr-img" />
        </div>
        <div class="qr-steps">
          <div class="step-item qr-step">
            <div class="step-number">1</div>
            <div class="step-desc">Download and save the QR code image</div>
          </div>
          <div class="step-item qr-step">
            <div class="step-number">2</div>
            <div class="step-desc">Use APP to scan QR code and pay</div>
          </div>
          <a class="action-btn download-btn" :href="recQrUrlImg"
            :download="`${orderInfo.orderId}-${orderInfo.amount}.png`">
            Download
          </a>
        </div>
      </div>
    </div>

    <!-- 弹出确认框 -->
    <div class="modal" v-if="showMsg1">
      <div class="modal-content">
        <div style="font-size: 0.95em;" v-if="showMsg1Over">{{ showMsg1Txt }}</div>
        <div style="font-size: 0.95em;" v-else>Please Wait ...</div>
        <button class="action-btn modal-close" @click="rcodeClose" v-if="showMsg1Over">Close</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as apis from "@/apis/apis";
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
import QRCode from "qrcode";

export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
    // 复制相关
      copyBankIf: false,
      copyOwnerIf: false,
      copyCardNoIf: false,
      copyAmountIf: false,
      recQrUrlImg: "",
      rcode: "",
      showMsg1: false,
      showMsg1Txt: "Operation successful",
      showMsg1Over: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
     //
    init() {
      this.rcode = this.orderInfo.tranMark;
      // 生成二维码;
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) {
              return;
            }
            this.recQrUrlImg = url;
          }
        );
      }
    },
    // 复制银行
    copyBank: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recBank,
        1,
        () => {
          this.copyBankIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyOwner: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recOwner,
        1,
        () => {
          this.copyOwnerIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyAccount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recAccount,
        1,
        () => {
          this.copyAccountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyCardNo: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recCardNo,
        1,
        () => {
          this.copyCardNoIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.copyAmountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyTranMark: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.tranMark,
        2,
        () => {
          this.copyTranMarkIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 提交code
    rcodeSubmit() {
      this.showMsg1 = true;
      this.showMsg1Over = false;
      apis
        .bkcd_np_rcode({
          id: this.orderInfo.orderId,
          rcode: this.rcode,
        })
        // eslint-disable-next-line
        .then((res) => {
          this.showMsg1Txt = "Reference Code submitted successfully！";
          this.showMsg1Over = true;
        });
    },
    rcodeClose() {
      this.showMsg1 = false;
      this.showMsg1Over = false;
    },
    // 上传文件
    fileOpen() {
      this.$refs.file1.click();
    },
    // 已选择文件
    fileSelected(event) {
      let that = this;
      // 获取文件
      const files = event.target.files;
      // 读取
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event) => {
        //console.log(reader.result);
        // console.log(event.target.result);
        // 创建 Image 对象
        var img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          var _this = this;
          // 大小处理
          let maxSize = 800;
          let width = img.width;
          let height = img.height;
          if (width > height) {
            height = maxSize * (height / width);
            width = maxSize;
          } else {
            width = maxSize * (width / height);
            height = maxSize;
          }
          // 获取 canvas 元素
          var canvas = document.createElement("canvas");
          // 绘制图像到 canvas
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(_this, 0, 0, width, height);
          // 使用 toDataURL 方法压缩图像
          var dataUrl = canvas.toDataURL("image/jpeg", 0.3);
          // 上传
          that.showMsg1 = true;
          that.showMsg1Over = false;
          apis
            .bkcd_np_cimg({
              id: that.orderInfo.orderId,
              cimg: dataUrl,
            })
            // eslint-disable-next-line
            .then((res) => {
              that.showMsg1Txt = "Image uploaded successfully!";
              that.showMsg1Over = true;
            });
        };
      };
    },
  },
};
</script>

<style>

</style>

<style lang="scss" scoped>

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.investment-checkout {
  font-family: 'Segoe UI', Roboto, Oxygen, sans-serif;
  background-color: #f0f2f5;
  min-height: 100vh;
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;

  // 顶部标题区域
  .title-section {
    text-align: center;
    margin-bottom: 1rem;

    h3 {
      font-size: 1.5rem;
      color: #165DFF;
      margin: 0 0 0.3rem;
      font-weight: 600;
    }

    .subtitle {
      color: #6B7280;
      font-size: 0.9rem;
      margin: 0;
    }
  }

  // 订单信息与倒计时区域
  .info-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.1rem;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 0.5rem;
    margin-bottom: 1rem;

    .order-info {
      flex: 1;
      min-width: 200px;
    }

    .time-left {
      color: #F53F3F;
      font-weight: 600;
      font-size: 0.9rem;
    }
  }

  // 新增的静态图片区域样式
  .static-image-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 0.8rem;
    margin-bottom: 1rem;
    text-align: center; // 图片居中显示

    .static-image {
      max-width: 100%; // 自适应容器宽度
      height: auto; // 保持图片比例
      border-radius: 6px; // 轻微圆角，和整体风格统一
      max-height: 300px; // 限制最大高度，避免图片过高
    }
  }

  // 收款信息
  .panel-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 0.8rem;
    margin-bottom: 1rem;

    .info-item {
      display: flex;
      align-items: center;
      padding: 0.6rem 0;
      border-bottom: 1px solid #F2F3F5;
      gap: 0.5rem;

      &:last-child {
        border-bottom: none;
      }

      .item-label {
        color: #6B7280;
        font-weight: 500;
        width: 70px;
        flex-shrink: 0;
        font-size: 0.9rem;
      }

      .item-value {
        flex: 1;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        font-size: 0.8rem;

        &.copied::after {
          content: "✓ Copied";
          position: absolute;
          right: 0;
          color: #00B42A;
          font-size: 0.7rem;
          font-weight: 500;
        }
      }

      .copy-btn {
        background-color: #165DFF;
        color: white;
        border: none;
        border-radius: 6px;
        padding: 0.3rem 0.6rem;
        cursor: pointer;
        font-size: 0.8rem;
        white-space: nowrap;
        flex-shrink: 0;
      }

      &.amount-item .item-value {
        color: #e53e3e;
        font-weight: 600;
      }
    }
  }

  // 操作区域
  .operation-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 0.8rem;
    margin-bottom: 1rem;

    .step-guide {
      display: flex;
      justify-content: space-around; // 均匀分布
      align-items: center;
      margin-bottom: 0.8rem;
      gap: 0.5rem;

      .step-item {
        flex: 1; // 两个步骤平分宽度
        text-align: center;

        .step-number {
          width: 1.8rem;
          height: 1.8rem;
          background-color: #165DFF;
          color: white;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.3rem;
          font-weight: 600;
          font-size: 0.8rem;
        }

        .step-desc {
          color: #4B5563;
          font-size: 0.8rem;
        }
      }
    }

    .input-group {
      display: flex;
      gap: 0.5rem;
      margin-bottom: 0.8rem;
      width: 100%;

      .ref-input {
        flex: 1;
        padding: 0.6rem;
        border: 1px solid #D1D5DB;
        border-radius: 6px;
        font-size: 0.9rem;
        min-width: 0;
      }

      .submit-btn {
        padding: 0.6rem 1rem;
        white-space: nowrap;
        background-color: #00B42A;
        color: white;
        border: none;
        border-radius: 6px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
        font-size: 0.9rem;
      }
    }

    .upload-container {
      width: 100%;

      .upload-btn {
        background-color: #FF7D00;
        color: white;
        width: 100%;
        font-size: 0.9rem;
        padding: 0.6rem 1rem;
        border: none;
        border-radius: 6px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
      }
    }

    .file-input {
      display: none;
    }
  }

  // 时间提示 
  .tips-notice-card {
    margin-bottom: 1rem;

    .notice-card {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      padding: 0.8rem;

      h4 {
        color: #1D2939;
        margin-top: 0;
        margin-bottom: 0.6rem;
        font-size: 1rem;
      }

      .notice-item {
        color: #4B5563;
        margin: 0 0 0.5rem 0;
        line-height: 1.4;
        font-size: 0.85rem;

        .warning {
          color: #F53F3F;
          font-weight: 500;
        }
      }
    }
  }

  // 二维码区域
  .qr-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 0.8rem;
    margin-bottom: 1rem;

    h4 {
      color: #1D2939;
      margin-top: 0;
      margin-bottom: 0.8rem;
      font-size: 1rem;
    }

    .qr-container {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
      justify-content: center;

      .qr-image-wrapper {
        flex-shrink: 0;
      }

      .qr-img {
        width: 120px;
        height: 120px;
        padding: 0.6rem;
        border: 1px solid #F2F3F5;
        border-radius: 6px;
        background-color: white;
      }

      .qr-steps {
        flex: 1;
        min-width: 180px;
      }

      .download-btn {
        background-color: #4E5BA6;
        color: white;
        display: inline-block;
        text-align: center;
        margin-top: 0.5rem;
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 6px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
        font-size: 0.8rem;
      }
    }
  }

  // 弹窗样式
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .modal-content {
      background-color: white;
      padding: 1.2rem;
      border-radius: 8px;
      width: 90%;
      max-width: 300px;
      text-align: center;
    }

    .modal-close {
      background-color: #165DFF;
      color: white;
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s;
      font-size: 0.9rem;
    }
  }

  // 响应式适配
  @media (max-width: 480px) {
    .info-card {
      flex-direction: column;
      align-items: flex-start;

      .time-left {
        margin-top: 0.3rem;
        padding-top: 0;
      }
    }

    .panel-card .info-item {
      flex-wrap: wrap;

      .item-value {
        margin-bottom: 0.3rem;
        width: 100%;
      }

      .copy-btn {
        width: 100%;
      }
    }

    .operation-card .step-guide {
      flex-direction: row; // 手机端仍保持左右（若想改回上下则改为column）
      gap: 0.5rem;
    }

    .input-group {
      flex-direction: column;

      .submit-btn {
        width: 100%;
      }
    }
  }
}
</style>